module.exports = __webpack_public_path__ + "img/profile-style-img3.99b1ca78.png";